import { render, staticRenderFns } from "./imports_select_rubric.vue?vue&type=template&id=767cc6c0&scoped=true&"
import script from "./imports_select_rubric.vue?vue&type=script&lang=js&"
export * from "./imports_select_rubric.vue?vue&type=script&lang=js&"
import style0 from "./imports_select_rubric.vue?vue&type=style&index=0&id=767cc6c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767cc6c0",
  null
  
)

export default component.exports